
import Vue from 'vue'
import { VProgressCircular } from 'vuetify/lib'
import JcdcRatings from '@/components/jcdc/JcdcRatings.vue'

export default Vue.extend({
  name: 'JcdcFavorite',
  components: {
    JcdcRatings,
    VProgressCircular,
  },
  props: {
    favorite: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      favoriteState: this.favorite ? 1 : 0,
    }
  },
})
